<template>
  <!-- 交付清单 -->
  <div class="deliveryList" id="deliveryList">
    <div class="deliveryList-top">
      <div class="deliveryList-topBox">
        <img src="../assets/bigTy.png" alt="" /><span>{{
          deliveryList.name
        }}</span>
      </div>
      <div class="deliveryList-topBox1">
        <span>{{ boxListChildren1.name }}</span
        ><span>{{ boxListChildren2.name }}</span>
      </div>
    </div>
    <div class="deliveryList-bottom">
      <div class="deliveryList-bottomLeft">
        <div
          class="bottomLeftbox"
          v-for="(item, index) in boxListChildren1.lists"
          :key="index"
        >
          <span>{{ item.name }}</span>
          <div class="">
            <span>{{ item.keywords }}</span>
          </div>
          <p :title="item.description">{{ item.description }}</p>
        </div>
      </div>
      <div class="deliveryList-bottomRight">
        <div
          class="bottomRightbox"
          v-for="(item, index) in boxListChildren2.lists"
          :key="index"
        >
          <span>{{ item.name }}</span>
          <div class="">
            <span>{{ item.keywords }}</span>
          </div>
          <p :title="item.description">{{ item.description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "deliveryList",
  props: {
    deliveryList: {
      type: Object
    }
  },
  data() {
    return {
      boxList: {},
      boxListChildren1: {},
      boxListChildren2: {}
    };
  },
  watch: {
    deliveryList(val) {
      this.boxListChildren1 = val.lists[0];
      this.boxListChildren2 = val.lists[1];
    }
  },
  created() {
    // this.boxListChildren1 = this.deliveryList[0];
    // this.boxListChildren2 = this.deliveryList[1];
  },
  methods: {}
};
</script>

<style scoped>
.deliveryList {
  /* background: #f6fafb; */
  margin-bottom: 64px;
}
.deliveryList-top {
  padding-top: 66px;
  height: 215px;
  background: #f6fafb;
  border: 1px solid #e9eeef;
  text-align: center;
}
.deliveryList-topBox {
  position: relative;
  margin-bottom: 60px;
}
.deliveryList-topBox img {
  position: absolute;
  top: -14px;
  left: 804px;
}
.deliveryList-topBox span {
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
}

.deliveryList-topBox1 span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
}
.deliveryList-topBox1 span:first-child {
  color: #df3a3a;
  margin-right: 64px;
}
.deliveryList-bottom {
  padding-top: 69px;
  width: 1280px;
  margin: 0 auto;
  position: relative;
  display: flex;
}
.deliveryList-bottomLeft {
  width: 640px;
  height: 306px;
  background: #ffffff;
  box-shadow: 4px 4px 30px 0px rgba(89, 98, 107, 0.16);
  padding: 20px;
  position: relative;
  top: -50px;
  left: 0;
  z-index: 998;
  display: flex;
  flex-wrap: wrap;
}
.bottomLeftbox {
  width: 276px;
  height: 123px;
  background: #f6fafb;
  border: 1px solid #e5e9ea;
  padding-top: 19px;
  padding-left: 19px;
  margin-right: 22px;
  margin-bottom: 20px;
}
.bottomLeftbox:nth-child(2n) {
  margin-right: 0;
}
.bottomLeftbox:nth-child(3) {
  margin-bottom: 0;
}
.bottomLeftbox:nth-child(4) {
  margin-bottom: 0;
}
.bottomLeftbox > span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
  display: block;
  margin-bottom: 9px;
}
.bottomLeftbox > div {
  width: fit-content;
  padding: 0 10px;
  height: 20px;
  background: linear-gradient(
    0deg,
    rgba(220, 57, 57, 0.1),
    rgba(255, 66, 66, 0.1)
  );
  line-height: 16px;
  text-align: center;
  align-items: center;
  margin-bottom: 22px;
}
.bottomLeftbox > div span {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ff4242;
}
.bottomLeftbox > p {
  width: 255px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #595959;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.deliveryList-bottomRight {
  width: 690px;
  height: 314px;
  background: #f6fafb;
  /* background-color: red; */
  padding: 20px;
  padding-left: 70px;
  position: relative;
  top: 0;
  right: 50px;
  display: flex;
  flex-wrap: wrap;
}
.bottomRightbox {
  width: 276px;
  height: 123px;
  background: #ffffff;
  border: 1px solid #e5e9ea;
  padding-top: 19px;
  padding-left: 19px;
  margin-right: 22px;
  margin-bottom: 20px;
}
.bottomRightbox:nth-child(2n) {
  margin-right: 0;
}
.bottomRightbox:nth-child(3) {
  margin-bottom: 0;
}
.bottomRightbox:nth-child(4) {
  margin-bottom: 0;
}
.bottomRightbox > span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
  display: block;
  margin-bottom: 9px;
}
.bottomRightbox > div {
  width: fit-content;
  padding: 0 10px;
  height: 20px;
  background: linear-gradient(
    0deg,
    rgba(220, 57, 57, 0.1),
    rgba(255, 66, 66, 0.1)
  );
  line-height: 16px;
  text-align: center;
  align-items: center;
  margin-bottom: 22px;
}
.bottomRightbox > div span {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ff4242;
}
.bottomRightbox > p {
  width: 255px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #595959;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/DeliveryList.vue